import './App.svelte.css';
/* src/App.svelte generated by Svelte v3.37.0 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	noop,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "../_snowpack/pkg/svelte/internal.js";

import {
	Draggable,
	CreateAreaContainer,
	GenerateCta,
	ResetButton,
	Footer
} from "./components/index.js";

function create_fragment(ctx) {
	let main;
	let createareacontainer;
	let t0;
	let draggable;
	let t1;
	let generatecta;
	let t2;
	let resetbutton;
	let t3;
	let footer;
	let current;
	let mounted;
	let dispose;
	add_render_callback(/*onwindowresize*/ ctx[1]);
	createareacontainer = new CreateAreaContainer({});
	draggable = new Draggable({});
	generatecta = new GenerateCta({});
	resetbutton = new ResetButton({});
	footer = new Footer({});

	return {
		c() {
			main = element("main");
			create_component(createareacontainer.$$.fragment);
			t0 = space();
			create_component(draggable.$$.fragment);
			t1 = space();
			create_component(generatecta.$$.fragment);
			t2 = space();
			create_component(resetbutton.$$.fragment);
			t3 = space();
			create_component(footer.$$.fragment);
		},
		m(target, anchor) {
			insert(target, main, anchor);
			mount_component(createareacontainer, main, null);
			append(main, t0);
			mount_component(draggable, main, null);
			append(main, t1);
			mount_component(generatecta, main, null);
			append(main, t2);
			mount_component(resetbutton, main, null);
			insert(target, t3, anchor);
			mount_component(footer, target, anchor);
			current = true;

			if (!mounted) {
				dispose = listen(window, "resize", /*onwindowresize*/ ctx[1]);
				mounted = true;
			}
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(createareacontainer.$$.fragment, local);
			transition_in(draggable.$$.fragment, local);
			transition_in(generatecta.$$.fragment, local);
			transition_in(resetbutton.$$.fragment, local);
			transition_in(footer.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(createareacontainer.$$.fragment, local);
			transition_out(draggable.$$.fragment, local);
			transition_out(generatecta.$$.fragment, local);
			transition_out(resetbutton.$$.fragment, local);
			transition_out(footer.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(main);
			destroy_component(createareacontainer);
			destroy_component(draggable);
			destroy_component(generatecta);
			destroy_component(resetbutton);
			if (detaching) detach(t3);
			destroy_component(footer, detaching);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let innerHeight;

	function onwindowresize() {
		$$invalidate(0, innerHeight = window.innerHeight)
	}

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*innerHeight*/ 1) {
			$: {
				if (innerHeight) document.body.style.minHeight = `${innerHeight}px`;
			}
		}
	};

	return [innerHeight, onwindowresize];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default App;